export default {
  "advent": {
    "season": "Adwentu",
    "feria": "{{day}} {{week}} tygodnia Adwentu",
    "sunday":  "{{week}} Niedziela Adwentu"
  },
  "christmastide": {
    "season": "Narodzenia Pańskiego",
    "day": "{{day}} boże Narodzenie",
    "octave": "{{count}} dzień w oktawie Narodzenia Pańskiego",
    "sunday": "{{count}} Niedziela po Narodzeniu Pańskim"
  },
  "epiphany": {
    "season": "Objawienie Pańskie",
    "before": "{{day}} przed Objawieniem Pańskim",
    "after": "{{day}} po Objawieniu Pańskim"
  },
  "ordinaryTime": {
    "season": "Zwykła",
    "feria": "{{day}} {{week}} tygodnia zwykłego",
    "sunday": "{{week}} Niedziela zwykła"
  },
  "lent": {
    "season": "Postu",
    "feria": "{{day}} {{week}} tygodnia Wielkiego Postu",
    "sunday": "{{week}} Niedziela Wielkiego Postu",
    "day_after_ash_wed": "{{day}} po Popielcu"
  },
  "holyWeek": {
    "season": "Wielki Tydzień",
    "feria": "{{day}} wielkiego tygodnia"
  },
  "eastertide": {
    "season": "Wielkanoc",
    "feria": "{{day}} {{week}} tygodnia wielkanocnego",
    "sunday":  "{{week}} Niedziela Wielkanocna",
    "octave": "{{day}} w oktawie Wielkanocy"
  },
  "celebrations": {
    "allSaints": "Wszystkich Świętych",
    "annunciation": "Zwiastowanie Pańskie",
    "ascension": "Wniebowstąpienie Pańskie",
    "ashWednesday": "Środa popielcowa",
    "assumption": "Wniebowzięcie Najświętszej Maryi Panny",
    "baptismOfTheLord": "Chrzest Pański",
    "birthOfJohnTheBaptist": "Narodzenie św. Jana Chrzciciela",
    "christmas": "Narodzenie Pańskie",
    "christTheKing": "Jezusa Chrystusa Króla Wszechświata",
    "corpusChristi": "Najświętszego Ciała i Krwi Chrystusa",
    "divineMercySunday": "2 Niedziela Wielkanocna czyli Miłosierdzia Bożego",
    "easter": "Niedziela Wielkanocna Zmartwychwstania Pańskiego",
    "epiphany": "Objawienie Pańskie",
    "goodFriday": "Wielki Piątek",
    "holyFamily": "Świętej Rodziny Jezusa, Maryi i Józefa",
    "holySaturday": "Wielka Sobota",
    "holyThursday": "Wielki Czwartek",
    "immaculateConception": "Niepokalane Poczęcie Najświętszej Maryi Panny",
    "immaculateHeartOfMary": "Niepokalanego Serca Najświętszej Maryi Panny",
    "josephHusbandOfMary": "Św. Józefa, Oblubieńca Najświętszej Maryi Panny",
    "maryMotherOfGod": "Świętej Bożej Rodzicielki Maryi",
    "palmSunday": "Niedziela Palmowa Męki Pańskiej",
    "pentecostSunday": "Niedziela Zesłania Ducha Świętego",
    "peterAndPaulApostles": "Świętych Apostołów Piotra i Pawła",
    "presentationOfTheLord": "Ofiarowanie Pańskie",
    "sacredHeartOfJesus": "Najświętszego Serca Pana Jezusa",
    "theExaltationOfTheHolyCross": "Podwyższenie Krzyża Świętego",
    "transfiguration": "Przemienienie Pańskie",
    "trinitySunday": "Niedziela Najświętszej Trójcy"
  },
  "sanctoral": {
    "allSouls": "Wspomnienie wszystkich wiernych zmarłych",
    "birthOfTheBlessedVirginMary": "Narodzenie Najświętszej Maryi Panny",
    "blessedAnielaSalawaVirgin": "Bł. Anieli Salawy, dziewicy",
    "blessedAntoniNowowiejskiBishopAndCompanionsMartyrs": "Błogosławionych męczenników Antoniego Juliana Nowowiejskiego, biskupa, i Towarzyszy",
    "blessedBogumilBishop": "Bł. Bogumiła, biskupa",
    "blessedBoleslawaMariaLamentVirginAndSaintAngelaMericiVirgin": "Bł. Bolesławy Marii Lament, dziewicy",
    "blessedBronislawaVirgin": "Bł. Bronisławy, dziewicy",
    "blessedCzeslawPriest": "Bł. Czesława, prezbitera",
    "blessedEdmundBojanowski": "Bł. Edmunda Bojanowskiego",
    "blessedHonoratKozminskiPriest": "Bł. Honorata Koźmińskiego, prezbitera",
    "blessedJakubStrzemieBishop": "Bł. Jakuba Strzemię, biskupa",
    "blessedJerzyMatulewiczBishop": "Bł. Jerzego Matulewicza, biskupa",
    "blessedJohnBeyzymPriest": "Bł. Jana Beyzyma, prezbitera",
    "blessedJohnMartinMoyePriest": "Bł. Jana Marcina Moyego, Kapłana",
    "blessedJolantaReligious": "Bł. Jolanty, zakonnicy",
    "blessedKarolinaKozkownaVirginAndMartyr": "Bł. Karoliny Kózkówny, dziewicy i męczennicy",
    "blessedMariaAssuntaPallottaVirgin": "Bł. Marii Assunty Pallotty, Dziewicy",
    "blessedMariaStellaAndCompanionsVirginsAndMartyrs": "Błogosławionych dziewic i męczennic Marii Stelli i Towarzyszek",
    "blessedMariaTeresaLedochowskaVirgin": "Bł. Marii Teresy Ledóchowskiej, dziewicy",
    "blessedMaryAngelaTruszkowskaVirgin": "Bł. Marii Angeli Truszkowskiej, dziewicy",
    "blessedMaryOfJesusTheGoodShepherdVirgin": "Bł. Marii od Pana Jezusa Dobrego Pasterza (Franciszki Siedliskiej), zakonnicy",
    "blessedMauriceTornayPriestAndMartyr": "Bł. Maurycego Tornaya, Kapłana i Męczennika",
    "blessedMichaelKozalBishopAndMartyr": "Bł. Michała Kozala, biskupa i męczennika",
    "blessedOdoricOfPordenonePriest": "Bł. Odoryka z Pordenone, Kapłana",
    "blessedRafalChylinskiPriest": "Bł. Rafała Chylińskiego, prezbitera",
    "blessedSalomeVirgin": "Bł. Salomei, zakonnicy",
    "blessedVincentKadlubekBishop": "Bł. Wincentego Kadłubka, biskupa",
    "blessedVincentLewoniukAndCompanionsMartyrsOfPratulin": "Błogosławionych męczenników Wincentego Lewoniuka i Towarzyszy",
    "blessedWladyslawOfGielniowPriest": "Bł. Władysława z Gielniowa, prezbitera",
    "chairOfSaintPeterApostle": "Katedry św. Piotra, Apostoła",
    "conversionOfSaintPaulApostle": "Nawrócenie św. Pawła, Apostoła",
    "dedicationOfTheBasilicaOfSaintMaryMajor": "Rocznica poświęcenia rzymskiej Bazyliki Najświętszej Maryi Panny",
    "dedicationOfTheBasilicasOfSaintsPeterAndPaulApostles": "Rocznica poświęcenia rzymskich bazylik świętych apostołów Piotra i Pawła",
    "dedicationOfTheLateranBasilica": "Rocznica poświęcenia Bazyliki Laterańskiej",
    "firstMartyrsOfTheChurchOfRome": "Świętych Pierwszych Męczenników Św. Kościoła Rzymskiego",
    "guardianAngels": "Świętych Aniołów Stróżów",
    "holyInnocentsMartyrs": "Św. Młodzianków, męczenników",
    "holyNameOfTheBlessedVirginMary": "Najświętszego Imienia Maryi",
    "maryMotherOfTheChurch": "Najświętszej Maryi Panny, Matki Kościoła",
    "ourLadyOfChina": "Najświętszej Maryi Panny z Chin",
    "ourLadyOfCzestochowa": "Najświętszej Maryi Panny Częstochowskiej",
    "ourLadyOfFatima": "Najświętszej Maryi Panny z Fatimy",
    "ourLadyOfGuadalupe": "Najświętszej Maryi Panny z Guadalupe",
    "ourLadyOfLoreto": "Najświętszej Maryi Panny Loretańskiej",
    "ourLadyOfLourdes": "Najświętszej Maryi Panny z Lourdes",
    "ourLadyOfMountCarmel": "Najświętszej Maryi Panny z Góry Karmel",
    "ourLadyOfSorrows": "Najświętszej Maryi Panny Bolesnej",
    "ourLadyOfTheRosary": "Najświętszej Maryi Panny Różańcowej",
    "ourLordJesusChristTheEternalHighPriest": "Jezusa Chrystusa, Najwyższego i Wiecznego Kapłana",
    "popeSaintJohnPaulII": "Św. Jana Pawła II, papieża",
    "popeSaintJohnXXIII": "Św. Jana XXIII, papieża",
    "presentationOfTheBlessedVirginMary": "Ofiarowanie Najświętszej Maryi Panny",
    "queenshipOfBlessedVirginMary": "Najświętszej Maryi Panny, Królowej",
    "saintAdalbertBishopAndMartyr": "Św. Wojciecha, biskupa i męczennika, głównego patrona Polski",
    "saintAgathaVirginAndMartyr": "Św. Agaty, dziewicy i męczennicy",
    "saintAgnesCaoGuiyingMartyr": "Św. Agnieszki Cao Guiying, Męczennicy",
    "saintAgnesVirginAndMartyr": "Św. Agnieszki, dziewicy i męczennicy",
    "saintAlbericCrescitelliPriestAndMartyr": "Św. Alberyka Crescitellego, Kapłana i Męczennika",
    "saintAlbertChmielowskiReligious": "Św. Brata Alberta Chmielowskiego, zakonnika",
    "saintAlbertTheGreatBishopAndDoctor": "Św. Alberta Wielkiego, biskupa i doktora Kościoła",
    "saintAloysiusGonzagaReligious": "Św. Alojzego Gonzagi, zakonnika",
    "saintAlphonsusMariaDeLiguoriBishopAndDoctorOfTheChurch": "Św. Alfonsa Marii Liguoriego, biskupa i doktora Kościoła",
    "saintAmbroseBishopAndDoctor": "Św. Ambrożego, biskupa i doktora Kościoła",
    "saintAndrewBobolaPriestAndMartyr": "Św. Andrzeja Boboli, prezbitera i męczennika",
    "saintAndrewDungLacAndCompanionsMartyrs": "Świętych męczenników Andrzeja Dung-Lac, prezbitera, i Towarzyszy",
    "saintAndrewKimTaegonPriestAndPaulChongHasangAndCompanionsMartyrs": "Świętych męczenników Andrzeja Kim Taegon, prezbitera, Pawła Chong Hasang i Towarzyszy",
    "saintAndrewTheApostle": "Św. Andrzeja, Apostoła",
    "saintAngelaMericiVirgin": "Św. Anieli Merici, dziewicy",
    "saintAnselmOfCanterburyBishopAndDoctorOfTheChurch": "Św. Anzelma, biskupa i doktora Kościoła",
    "saintAnthonyMaryClaretBishop": "Św. Antoniego Marii Clareta, biskupa",
    "saintAnthonyOfEgyptAbbot": "Św. Antoniego, opata",
    "saintAnthonyOfPaduaPriestAndDoctor": "Św. Antoniego z Padwy, prezbitera i doktora Kościoła",
    "saintAnthonyZaccariaPriest": "Św. Antoniego Marii Zaccarii, prezbitera",
    "saintApollinaris": "Św. Apolinarego, biskupa i męczennika",
    "saintAthanasiusBishopAndDoctor": "Św. Atanazego, biskupa i doktora Kościoła",
    "saintAugustineOfCanterburyBishop": "Św. Augustyna z Canterbury, biskupa",
    "saintAugustineOfHippoBishopAndDoctorOfTheChurch": "Św. Augustyna, biskupa i doktora Kościoła",
    "saintAugustineZhaoRongPriestAndCompanionsMartyrs": "Świętych męczenników Augustyna Zhao Rong, Kapłana i Towarzyszy",
    "saintAugustineZhaoRongPriestAndMartyr": "Św. Augustyna Zhao Rong, Kapłana i Męczennika",
    "saintBarbaraVirginAndMartyr": "Św. Barbary, dziewicy i męczennicy",
    "saintBarnabasTheApostle": "Św. Barnaby, Apostoła",
    "saintBartholomewTheApostle": "Św. Bartłomieja, Apostoła",
    "saintBedeTheVenerablePriestAndDoctorSaintGregoryViiPopeSaintMaryMagdaleneDePazziVirgin": "Św. Bedy Czcigodnego, prezbitera i doktora Kościoła/Św. Grzegorza VII, papieża/Św. Marii Magdaleny de Pazzi, dziewicy",
    "saintBenedictOfNursiaAbbot": "Św. Benedykta, opata, patrona Europy",
    "saintBernardineOfSienaPriest": "Św. Bernardyna ze Sieny, prezbitera",
    "saintBernardOfClairvauxAbbotAndDoctorOfTheChurch": "Św. Bernarda, opata i doktora Kościoła",
    "saintBlaseBishopAndMartyrSaintAnsgarBishop": "Św. Błażeja, biskupa i męczennika/Św. Ansgara, biskupa",
    "saintBonaventureBishopAndDoctor": "Św. Bonawentury, biskupa i doktora Kościoła",
    "saintBonifaceBishopAndMartyr": "Św. Bonifacego, biskupa i męczennika",
    "saintBridgetOfSwedenReligious": "Św. Brygidy, zakonnicy, patronki Europy",
    "saintBrunoBonifaceOfQuerfurtBishopAndMartyr": "Św. Brunona Bonifacego z Kwerfurtu, biskupa i męczennika",
    "saintBrunoPriest": "Św. Brunona, prezbitera",
    "saintCallistusIPopeAndMartyr": "Św. Kaliksta I, papieża i męczennika",
    "saintCamillusDeLellisPriest": "Św. Kamila de Lellis, prezbitera",
    "saintCamillusDeLellisPriestOrSaintHenryBishopAndMartyr": "Św. Kamila de Lellis, prezbitera/Św. Henryka",
    "saintCasimir": "Św. Kazimierza",
    "saintCatherineOfAlexandriaVirginAndMartyr": "Św. Katarzyny Aleksandryjskiej, dziewicy i męczennicy",
    "saintCatherineOfSienaVirginAndDoctorOfTheChurch": "Św. Katarzyny Sieneńskiej, dziewicy i doktora Kościoła, patronki Europye",
    "saintCeciliaVirginAndMartyr": "Św. Cecylii, dziewicy i męczennicy",
    "saintCharbelMakhloufPriestAndHermit": "Św. Sarbeliusza Makluf, prezbitera",
    "saintCharlesBorromeoBishop": "Św. Karola Boromeusza, biskupa",
    "saintChristopherMagallanesAndCompanionsMartyrs": "Świętych męczenników Krzysztofa Magallanesa, prezbitera, i Towarzyszy",
    "saintClareVirgin": "Św. Klary, dziewicy",
    "saintClementIPopeAndMartyrSaintColumbanReligious": "Św. Klemensa I, papieża i męczennika/Św. Kolumbana, zakonnika",
    "saintCyrilOfAlexandriaBishopAndDoctor": "Św. Cyryla Aleksandryjskiego, biskupa i doktora Kościoła",
    "saintCyrilOfJerusalemBishopAndDoctor": "Św. Cyryla Jerozolimskiego, biskupa i doktora Kościoła",
    "saintDamasusIPope": "Św. Damazego I, papieża",
    "saintDenisAndCompanionsMartyrsSaintJohnLeonardiPriest": "Świętych męczenników Dionizego, biskupa, i Towarzyszy/Św. Jana Leonardiego, prezbitera",
    "saintDominicPriest": "Św. Dominika, prezbitera",
    "saintElizabethOfHungary": "Św. Elżbiety Węgierskiej, zakonnicy",
    "saintElizabethOfPortugal": "Św. Elżbiety Portugalskiej",
    "saintEphremDeaconAndDoctor": "Św. Efrema, diakona i doktora Kościoła",
    "saintEusebiusOfVercelliBishopSaintPeterJulianEymardPriest": "Św. Euzebiusza z Vercelii, biskupa/Św. Piotra Juliani Eymarda, prezbitera",
    "saintFaustinaKowalskaVirginAndReligious": "Św. Faustyny Kowalskiej, dziewicy",
    "saintFidelisOfSigmaringenPriestAndMartyr": "Św. Fidelisa z Sigmaringen, prezbitera i męczennika",
    "saintFlorianMartyr": "Św. Floriana, męczennika",
    "saintFrancesOfRomeReligious": "Św. Franciszki Rzymianki, zakonnicy",
    "saintFrancisDeSalesBishopAndDoctor": "Św. Franciszka Salezego, biskupa i doktora Kościoła",
    "saintFrancisDiazPriestAndCompanionsMartyrs": "Świętych męczenników Franciszka Diaza, Kapłana i Towarzyszy",
    "saintFrancisFernandezDeCapillasPriestAndMartyr": "Św. Franciszka Fernandeza de Capillas, Kapłana i Męczennika",
    "saintFrancisOfAssisi": "Św. Franciszka z Asyżu",
    "saintFrancisOfPaolaHermit": "Św. Franciszka z Paoli, pustelnika",
    "saintFrancisXavierPriest": "Św. Franciszka Ksawerego, prezbitera",
    "saintGabrieltaurinDufresseBishopAndMartyr": "Św. Gabriel-Taurina Dufresse, Biskupa i Męczennika",
    "saintGeorgeMartyrSaintAdalbertBishopAndMartyr": "Św. Grzegorza, męczennika/Św. Wojciecha, biskupa i męczennika",
    "saintGregoryTheGreatPopeAndDoctor": "Św. Grzegorza Wielkiego, papieża i doktora Kościoła",
    "saintHedwigReligiousSaintMargaretMaryAlacoqueVirgin": "Św. Jadwigi Śląskiej/Św. Małgorzaty Marii Alacoque, dziewicy",
    "saintHenryBishopAndMartyr": "Św. Henryka, cesarza",
    "saintHilaryOfPoitiersBishopAndDoctor": "Św. Hilarego, biskupa i doktora Kościoła",
    "saintHyacinthPriest": "Św. Jacka, prezbitera",
    "saintIgnatiusOfAntiochBishopAndMartyr": "Św. Ignacego Antiocheńskiego, biskupa i męczennika",
    "saintIgnatiusOfLoyolaPriest": "Św. Ignacego z Loyoli, prezbitera",
    "saintIrenaeusBishopAndMartyr": "Św. Ireneusza, biskupa i męczennika",
    "saintIsidoreOfSevilleBishopAndDoctorOfTheChurch": "Św. Izydora, biskupa i doktora Kościoła",
    "saintJamesApostle": "Św. Jakuba, Apostoła",
    "saintJaneFrancesDeChantalReligious": "Św. Joanny Franciszki de Chantal, zakonnicy",
    "saintJanuariusBishopAndMartyr": "Św. Januarego, biskupa i męczennika",
    "saintJeanVianneyTheCureOfArsPriest": "Św. Jana Marii Vianneya, prezbitera",
    "saintJeromeEmilianiSaintJosephineBakhitaVirgin": "Św. Hieronima Emilianiego/Św. Józefiny Bakhity, dziewicy",
    "saintJeromePriestAndDoctor": "Św. Hieronima, prezbitera i doktora Kościoła",
    "saintJoachimHoMartyr": "Św. Joachima Ho, Męczennika",
    "saintJohnBaptistDeLaSallePriest": "Św. Jana Chrzciciela de la Salle, prezbitera",
    "saintJohnBoscoPriest": "Św. Jana Bosko, prezbitera",
    "saintJohnChrysostomBishopAndDoctor": "Św. Jana Chryzostoma, biskupa i doktora Kościoła",
    "saintJohnDamascenePriestAndDoctor": "Św. Jana Damasceńskiego, prezbitera i doktora Kościoła",
    "saintJohnEudesPriest": "Św. Jana Eudesa, prezbitera",
    "saintJohnGabrielPerboyrePriestAndMartyr": "Św. Jana Gabriela Perboyre'a, Kapłana i Męczennika",
    "saintJohnIPopeAndMartyr": "Św. Jana I, papieża i męczennika",
    "saintJohnOfCapistranoPriest": "Św. Jana Kapistrana, prezbitera",
    "saintJohnOfDuklaPriest": "Św. Jana z Dukli, prezbitera",
    "saintJohnOfGodReligious": "Św. Jana Bożego, zakonnika",
    "saintJohnOfKantyPriest": "Św. Jana Kantego, prezbitera",
    "saintJohnOfTheCrossPriestAndDoctor": "Św. Jana od Krzyża, prezbitera i doktora Kościoła",
    "saintJohnOfTrioraPriestAndMartyr": "Św. Jana z Triory, Kapłana i Męczennika",
    "saintJohnSarkanderPriestAndMartyrSaintZdzislawa": "Św. Jana Sarkandra, prezbitera i męczennika/Św. Zdzisławy",
    "saintJohnTheApostleAndEvangelist": "Św. Jana, Apostoła i Ewangelisty",
    "saintJosaphatBishopAndMartyr": "Św. Jozafata, biskupa i męczennika",
    "saintJosefBilczewskiBishop": "Św. Józefa Bilczewskiego, biskupa",
    "saintJosephTheWorker": "Św. Józefa, rzemieślnika",
    "saintJosephYuanPriestAndMartyr": "Św. Józefa Yuana, Kapłana i Męczennika",
    "saintJosephZhangDapengMartyr": "Św. Józefa Zhang Dapenga, Męczennika",
    "saintJuanDiegoCuauhtlatoatzin": "Św. Jana Diego Cuahtlatoatzin",
    "saintJustinMartyr": "Św. Justyna, męczennika",
    "saintKingaVirgin": "Św. Kingi, dziewicy",
    "saintLaurenceWangBingAndCompanionsMartyrsSaintJosephFreinademetzPriest": "Świętych męczenników Wawrzyńca Wang Binga i Towarzyszy albo Św. Józefa Freinademetza, Kapłana",
    "saintLawrenceBaiXiaomanMartyr": "Św. Wawrzyńa Bai Xiaomana, Męczennika",
    "saintLawrenceOfBrindisiPriestAndDoctor": "Św. Wawrzyńca z Brindisi, prezbitera i doktora Kościoła",
    "saintLawrenceOfRomeDeaconAndMartyr": "Św. Wawrzyńca, diakona i męczennika",
    "saintLeoManginPriestAndCompanionsMartyrs": "Świętych męczenników Leona Mangina, Kapłana i Towarzyszy",
    "saintLeoTheGreatPopeAndDoctor": "Św. Leona Wielkiego, papieża i doktora Kościoła",
    "saintLouisSaintJosephOfCalasanzPriest": "Św. Ludwika/Św. Józefa Kalasantego, prezbitera",
    "saintLucyOfSyracuseVirginAndMartyr": "Św. Łucji, dziewicy i męczennicy",
    "saintLucyYiZhenmeiVirginAndMartyr": "Św. Łucji Yi Zhenmei, Dziewicy i Męcznnicy",
    "saintLukeTheEvangelist": "Św. Łukasza, Ewangelisty",
    "saintMargaretOfScotlandSaintGertrudeTheGreatVirgin": "Św. Małgorzaty Szkockiej/Św. Gertrudy, dziewicy",
    "saintMariaGorettiVirginAndMartyr": "Św. Marii Goretti, dziewicy i męczennicy",
    "saintMarkTheEvangelist": "Św. Marka, Ewangelisty",
    "saintMartha": "Św. Marty",
    "saintMartinDePorresReligious": "Św. Marcina de Porres, zakonnika",
    "saintMartinIPopeAndMartyr": "Św. Marcina I, papieża i męczennika",
    "saintMartinOfToursBishop": "Św. Marcina z Tours, biskupa",
    "saintMartinWuXueshengAndCompanionsMartyrs": "Świętych męczenników Marcina Wu Xueshenga i Towarzyszy",
    "saintMaryMagdalene": "Św. Marii Magdaleny",
    "saintMatthewApostleAndEvangelist": "Św. Mateusza, Apostoła i Ewangelisty",
    "saintMatthiasTheApostle": "Św. Macieja, Apostoła",
    "saintMaximilianMaryKolbePriestAndMartyr": "Św. Maksymiliana Marii Kolbego, prezbitera i męczennika",
    "saintMelchiorGrodzieckiPriestAndMartyr": "Św. Melchiora Grodzieckiego, prezbitera i męczennika",
    "saintMonica": "Św. Moniki",
    "saintNicholasBishop": "Św. Mikołaja, biskupa",
    "saintNorbertBishop": "Św. Norberta, biskupa",
    "saintOttoOfBambergBishop": "Św. Ottona, biskupa",
    "saintPatrickBishop": "Św. Patryka, biskupa",
    "saintPaulChenChangpinAndCompanionsMartyrs": "Świętych męczenników Pawła Chen Changpina i Towarzyszy",
    "saintPaulinusOfNolaBishopSaintsJohnFisherBishopAndThomasMoreMartyrs": "Św. Paulina z Noli, biskupa/Świętych męczenników Jana Fishera, biskupa i Tomasza More’a",
    "saintPaulLiuHanzouPriestAndMartyr": "Św. Pawła Liu Hanzou, Kapłana i Męczennika",
    "saintPaulMikiAndCompanionsMartyrs": "Świętych męczenników Pawła Miki i Towarzyszy",
    "saintPeterCanisiusPriestAndDoctor": "Św. Piotra Kanizjusza, prezbitera i doktora Kościoła",
    "saintPeterChanelPriestAndMartyrSaintLouisGrignonDeMontfortPriest": "Św. Piotra Chanela, prezbitera i męczennika/Św. Ludwika Marii Grignion de Montfort, prezbitera",
    "saintPeterChrysologusBishopAndDoctor": "Św. Piotra Chryzologa, biskupa i doktora Kościoła",
    "saintPeterClaverPriest": "Św. Piotra Klawera, prezbitera",
    "saintPeterDamianBishopAndDoctorOfTheChurch": "Św. Piotra Damianiego, biskupa i doktora Kościoła",
    "saintPeterLiuMartyr": "Św. Piotra Liu, Męczennika",
    "saintPeterSanzBishopAndMartyr": "Św. Piotra Sanza, Biskupa i Męczennika",
    "saintPeterWuMartyr": "Św. Piotra Wu, Męczennika",
    "saintPhilipNeriPriest": "Św. Filipa Nereusza, prezbitera",
    "saintPioOfPietrelcinaPadrePioPriest": "Św. Pio z Pietrelciny, prezbitera",
    "saintPiusVPope": "Św. Piusa V, papieża",
    "saintPiusXPope": "Św. Piusa X, papieża",
    "saintPolycarpBishopAndMartyr": "Św. Polikarpa, biskupa i męczennika",
    "saintRafalKalinowskiPriest": "Św. Rafała Kalinowskiego, prezbiterat",
    "saintRaymondOfPenyafortPriest": "Św. Rajmunda z Penyafort, prezbitera",
    "saintRitaOfCascia": "Św. Rity z Cascii, zakonnicy",
    "saintRobertBellarmineBishopAndDoctor": "Św. Roberta Bellarmina, biskupa i doktora Kościoła",
    "saintRomualdAbbot": "Św. Romualda, opata",
    "saintRoseOfLima": "Św. Róży z Limy, dziewicy",
    "saintsAndrewZorardAndBenedictHermits": "Świętych pustelników Andrzeja Świerada i Benedykta",
    "saintsAugustineZhaoRongPriestAndCompanionsMartyrs": "Świętych męczenników Augustyna Zhao Rong, prezbitera, i Towarzyszy",
    "saintsBasilTheGreatAndGregoryNazianzenBishopsAndDoctors": "Świętych Bazylego Wielkiego i Grzegorza z Nazjanzu, biskupów i doktorów Kościoła",
    "saintsBenedyktJanMateuszIsaakAndKrystynMartyrs": "Świętych Benedykta, Jana, Mateusza, Izaaka i Krystyna, pierwszych męczenników Polski",
    "saintsCharlesLwangaAndCompanionsMartyrs": "Świętych męczenników Karola Lwangi i Towarzyszy",
    "saintScholasticaVirgin": "Św. Scholastyki, dziewicy",
    "saintsCorneliusPopeAndCyprianBishopMartyrs": "Świętych męczenników Korneliusza, papieża, i Cypriana, biskupa",
    "saintsCosmasAndDamianMartyrs": "Świętych męczenników Kosmy i Damiana",
    "saintsCyrilMonkAndMethodiusBishop": "Świętych Cyryla, mnicha i Metodego, biskupa, patronów Europy",
    "saintsFabianPopeAndSebastianMartyrs": "Św. Fabiana, papieża i męczennika/Św. Sebastiana, męczennika",
    "saintsGregoryGrassiFrancisFogollaAndAnthonyFantosatiBishopsAndCompanionsMartyrs": "Świętych męczenników Grzegorza Grassiego, Franciszka Fogolli i Antoniego Fantosatiego, Biskupów i Towarzyszy",
    "saintSimonOfLipnicaPriest": "Św. Szymona z Lipnicy, prezbitera",
    "saintSixtusIiPopeAndCompanionsMartyrsSaintCajetanPriest": "Świętych męczenników Sykstusa II, papieża, i Towarzyszy/Św. Kajetana, prezbitera",
    "saintsJeanDeBrebeufAndIsaacJoguesPriestsAndCompanionsMartyrsSaintPaulOfTheCrossPriest": "Świętych męczenników Jana de Brebeuf, Izaaka Jogues’a, prezbiterów oraz Towarzyszy/Św. Pawła od Krzyża, prezbitera",
    "saintsJoachimAndAnne": "Świętych Rodziców NMP Joachima i Anny",
    "saintsLouisVersigliaBishopAndCallistusCaravarioPriestMartyrs": "Świętych Alojzego Versiglii, Biskupa i Kaliksta Caravaria, Kapłana",
    "saintsMarcellinusAndPeterMartyrs": "Świętych męczenników Marcelina i Piotra",
    "saintsMichaelGabrielAndRaphaelArchangels": "Świętych Archaniołów Michała, Gabriela i Rafała",
    "saintsNereusAndAchilleusMartyrsSaintPancrasMartyr": "Świętych męczenników Nereusza i Achillesa/Św. Pankracego, męczennika",
    "saintsPerpetuaAndFelicityMartyrs": "Świętych męczennic Perpetuy i Felicyty",
    "saintsPhilipAndJamesApostles": "Świętych Apostołów Filipa i Jakuba",
    "saintsPontianPopeAndHippolytusPriestMartyrs": "Świętych męczenników Poncjana, papieża i Hipolita, prezbiteras",
    "saintsSimonAndJudeApostles": "Świętych Apostołów Szymona i Judy Tadeusza",
    "saintStanislausBishopAndMartyr": "Św. Stanisława, biskupa i męczennika, głównego patrona Polski",
    "saintStanislausKazimierczykPriest": "Św. Stanisława Kazimierczyka, prezbitera",
    "saintStanislausKostkaReligious": "Św. Stanisława Kostki, zakonnika, patrona Polski",
    "saintStephenOfHungary": "Św. Stefana Węgierskiego",
    "saintStephenTheFirstMartyr": "Św. Szczepana, pierwszego męczennika",
    "saintsTimothyAndTitusBishops": "Świętych biskupów Tymoteusza i Tytusa",
    "saintSylvesterIPope": "Św. Sylwestra I, papieża",
    "saintTeresaBenedictaOfTheCrossEdithSteinVirginAndMartyr": "Św. Teresy Benedykty od Krzyża, dziewicy i męczennicy, patronki Europy",
    "saintTeresaOfJesusVirginAndDoctorOfTheChurch": "Św. Teresy od Jezusa, dziewicy i doktora Kościoła",
    "saintThereseOfTheChildJesusVirginAndDoctor": "Św. Teresy od Dzieciątka Jezus, dziewicy i doktora Kościoła",
    "saintThomasAquinasPriestAndDoctor": "Św. Tomasza z Akwinu, prezbitera i doktora Kościoła",
    "saintThomasBecketBishopAndMartyr": "Św. Tomasza Becketa, biskupa i męczennika",
    "saintThomasTheApostle": "Św. Tomasza, Apostoła",
    "saintTuribiusOfMogrovejoBishop": "Św. Turybiusza z Mongrovejo, biskupa",
    "saintUrsulaLedochowskaVirgin": "Św. Urszuli Ledóchowskiej, dziewicy",
    "saintVincentDeaconAndMartyr": "Św. Wincentego, diakona i męczennika",
    "saintVincentDePaulPriest": "Św. Wincentego à Paulo, prezbitera",
    "saintVincentFerrerPriest": "Św. Wincentego Ferreriusza, prezbitera",
    "saintVincentPallottiPriest": "Św. Wincentego Pallottiego, prezbitera",
    "saintWenceslausMartyrSaintsLawrenceRuizAndCompanionsMartyrs": "Św. Wacława, męczennika/Świętych męczenników Wawrzyńca Ruiz i Towarzyszy",
    "saintZygmuntGorazdowskiPriest": "Św. Zygmunta Gorazdowskiego, prezbitera",
    "saintZygmuntSzczesnyFelinskiBishop": "Św. Zygmunta Szczęsnego Felińskiego, biskupa",
    "sevenHolyFoundersOfTheServiteOrder": "Świętych siedmiu założycieli Zakonu Serwitów Najświętszej Maryi Panny",
    "sevenMartyredNunsFromTheFranciscanMissionariesOfMary": "Siedmiu męcznnic ze Zgromadzenia Franciszkanek Misjonarek Maryi",
    "theBeheadingOfSaintJohnTheBaptistMartyr": "Męczeństwo św. Jana Chrzciciela",
    "theMostHolyNameOfJesus": "Najświętszego Imienia Jezus",
    "visitationOfTheBlessedVirginMary": "Nawiedzenie Najświętszej Maryi Panny"
  }
};
